module.exports = __webpack_public_path__ + "img/golden-ticket-display.2c11fc6a.png";